import { render, staticRenderFns } from "./AddMatchingOrder.vue?vue&type=template&id=f568e1a0&scoped=true&"
import script from "./AddMatchingOrder.vue?vue&type=script&lang=js&"
export * from "./AddMatchingOrder.vue?vue&type=script&lang=js&"
import style0 from "./AddMatchingOrder.vue?vue&type=style&index=0&id=f568e1a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f568e1a0",
  null
  
)

export default component.exports